import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import { CartLineItem } from '@/types/productGridTypes';
import { RequiredPaymentDetail } from '@/types/CartTypes';

@Module({namespaced: true})
export default class productGridModule extends VuexModule {
  cartLineItems: CartLineItem[] = [];
  totalCartAmount: number = 0;
  requiredPaymentDetail: RequiredPaymentDetail = {} as RequiredPaymentDetail;

  get cartLineItemArr() {
    return this.cartLineItems;
  }

  get cartTotalAmount() {
    return this.totalCartAmount;
  }

  get getRequiredPaymentDetail() {
    return this.requiredPaymentDetail;
  }

  @Mutation
  setCartLineItem(prdtCatalogue: CartLineItem) {
    this.cartLineItems.push(prdtCatalogue);
  }

  @Mutation
  resetProperties() {
    this.cartLineItems =[];
    this.totalCartAmount =0;
    this.requiredPaymentDetail = {} as RequiredPaymentDetail;
  }

  @Mutation
  setCartTotal(total: number) {
    this.totalCartAmount = total;
  }

  @Mutation
  setRequiredPaymentDetail(value: RequiredPaymentDetail) {
    this.requiredPaymentDetail = value;
  }

  @Action({ commit: 'setCartLineItem', rawError: true })
  async addCartLineItem(payload: CartLineItem): Promise<CartLineItem> {
    return payload;
  }

  @Action({ commit: 'setCartTotal', rawError: true })
  async addCartTotal(payload: number): Promise<number> {
    return payload;
  }

  @Action({ commit: 'setRequiredPaymentDetail', rawError: true })
  async addRequiredPaymentDetail(payload: RequiredPaymentDetail): Promise<RequiredPaymentDetail> {
    return payload;
  }

  @Action({ commit: 'resetProperties', rawError: true })
  async reset(){
  }
}

